import { Megaphone } from "lucide-react";

/**
 * SponsorBlock — clearly-labelled sponsor-ready content block (non-deceptive).
 * Placeholder slot for Phase 1.
 */
export const SponsorBlock = () => {
  return (
    <div
      data-testid="sponsor-block"
      className="relative overflow-hidden rounded-2xl border border-brand-navy bg-brand-navy/30 p-8 sm:p-10"
    >
      <div className="bg-grid pointer-events-none absolute inset-0 opacity-20" />
      <div className="relative z-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-brand-royal/30 bg-brand-bg text-brand-cyan">
            <Megaphone className="h-6 w-6" />
          </div>
          <div>
            <span className="font-mono-data text-[10px] font-semibold uppercase tracking-[0.25em] text-brand-silver">
              Sponsored Placement
            </span>
            <h3 className="mt-1 font-display text-xl font-semibold text-white">
              Reach an engaged sports audience
            </h3>
            <p className="mt-1 max-w-xl text-sm leading-relaxed text-brand-silver">
              Sponsor-ready content block. Newsletter sponsorship and native
              placements available as the platform scales.
            </p>
          </div>
        </div>
        <a
          href="#"
          data-testid="sponsor-cta"
          className="inline-flex shrink-0 items-center justify-center rounded-lg border border-brand-royal px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-brand-royal"
        >
          Partner with us
        </a>
      </div>
    </div>
  );
};

export default SponsorBlock;
